import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { TransactionConfigurationRoutes } from '../../../routes/HomeRoutes/TransactionConfigurationRoutes';

export const TransactionConfigurationLayout = () => <SwitchRoute routes={TransactionConfigurationRoutes} />;
